import React from 'react';
import { Modal, Button, Dropdown, Menu, DatePicker, Pagination } from 'antd';
import { BaseComponent, request } from '@cm-sites-webber/components';
import { openNewWindow } from '@cm-sites-webber/components/es/components/utils';
import moment from 'moment';
import Scrollbars from 'react-custom-scrollbars';
import PropTypes from 'prop-types';

import SearchTemplate from '../../../../newMediaMatrix/components/searchTemplate/SearchTemplate';
import TableTemplate from '../../../../newMediaMatrix/components/TableTemplate/TableTemplate';
import BatchEntry from './components/batchEntry';
import ContentShow from './components/contentShow';

class HistoricalRelease extends BaseComponent {

    static propTypes = {
        styleOut: PropTypes.object,
    };
    static defaultProps = {
        styleOut: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            params: {
                page: 1,
                size: 10,
                keyWord: "",
                startDate: null,
                endDate: null,
            },
            item: {}, //父组件数据
            dataSource: [],
            total: 0,
        };
        this.contentShowRef = React.createRef();

        this.columns = [
            {
                title: "标题",
                dataIndex: "title",
                width: 460,
                render:(text,record,index)=>{
                    return (
                        <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",maxWidth: "740px",cursor: "pointer"}} title={text} onClick={()=>this. titleClick(record)} >
                            {text}
                        </div>
                    )
                }
            },
            {
                title: "录入时间",
                dataIndex: "publishTime",
                render: (text,record,index) => {
                    return moment(text).format("YYYY-MM-DD");
                }
            },
            {
                title: "账号名称",
                dataIndex: "positionName",
            },
            {
                title: "主责单位",
                dataIndex: "createDeptName",
            }
        ];
    }

    static getDerivedStateFromProps(props,state) {
        if (props.item !== state.item) {
            return {
                ...state,
                item: {
                    ...props.item
                }
            }
        }
        return null
    }

    componentDidMount() {
        this.createPostMessage((e)=>{
            try {
                let message = null
                if (e['data']&&typeof JSON.parse(e['data']) === 'object') {
                    message = JSON.parse(e['data'])['message'];
                }
                if (message === "请求刷新父页面") {
                    this.getHistoricalRelease();
                    e.source.close();
                }
            } catch (error) {
                console.log(error);
            }
        },"historicalRelease")
    }

    componentWillUnmount() {
        this.destroyPostMessage("historicalRelease");
    }

    // 表头搜索
    renderSearchTemplate() {
        const dateValue = [this.state.params.startDate?moment(this.state.params.startDate):null,this.state.params.endDate?moment(this.state.params.endDate):null];
        const dateRang = (
            <DatePicker.RangePicker 
                value={dateValue}  
                format={"YYYY-MM-DD"}
                onChange={(times)=>{
                    this.onSearch({startDate: times[0]?.set({hour:0,minute:0,second:0}).valueOf(),endDate: times[1]?.set({hour:23,minute:59,second:59}).valueOf(),})
                }} />
        )
        const btnList = [
            [
                {
                    type: 1,
                    key: "date",
                    component:dateRang,
                    labelName: "自定义时间",
                    styleOut: { float: 'left'},
                },
                {
                    type: 2,
                    key: "search",
                    component: "search",
                    value: this.state.params.keyWord,
                    placeholder: "请输入",
                    onChange: (e)=> {this.setState({params: {...this.state.params,keyWord:e}})},
                    onSearch: (e)=>{this.onSearch({keyWord:e})},
                    styleOut: { float: 'left'},
                },
                {
                    type:2,
                    key: "reset",
                    component: "button",
                    labelName: "重置",
                    onChange:() => this.reset(),
                }
            ]
        ];
        return (
            <SearchTemplate
                btnList={btnList}
                onResize={()=>{}}
            />
        )
    }

    // 表格
    renderTableTemplate() {
        return (
            <>
                <TableTemplate
                    columns={this.columns}
                    dataSource={this.state.dataSource}
                    onResize={()=>{}}
                />
                <ContentShow ref={this.contentShowRef} />
            </>
        )
    }

    // 分页
    renderPagination() {
        const { total, params } = this.state;
        return (
            <div style={{display: 'flex', justifyContent: 'right', padding: '20px 32px',borderTop: "1px solid #e8e8e8",height:72}}>
                <Pagination
                    // 是否可以改变 pageSize
                    showSizeChanger
                    // 是否可以快速跳转至某页
                    showQuickJumper
                    // pageSize 变化的回调
                    onShowSizeChange={(current, size)=>{
                        this.onPaginationChange(current,size);
                    }}
                    onChange={(page, pageSize)=>{
                        this.onPaginationChange(page,pageSize);
                    }}
                    // 当前页数
                    current={params.page}
                    // 禁用分页
                    disabled={false}
                    // 默认的当前页数
                    defaultCurrent={1}
                    // 默认的每页条数
                    defaultPageSize={10}
                    // 只有一页时是否隐藏分页器
                    hideOnSinglePage={false}
                    // 指定每页可以显示多少条
                    pageSizeOptions={['10', '20', '30', '40']}
                    // 每页条数
                    pageSize={params.size}
                    // 数据总数
                    total={total}
                    // 用于显示数据总量和当前数据顺序
                    showTotal={(total) => `共 ${total} 条`}
                />
            </div>
        )
    }

    renderFooterButton() {
        const { item } = this.state;
        const btnList = (
            <Menu id={"menu"}>
                <Menu.Item>
                    <a onClick={()=>window.openEditById({configName:"newMediaContentEntryEditor",id:0,params: ({mediaCode:item.code})})}>录入内容</a>
                </Menu.Item>
                <Menu.Item>
                    <BatchEntry data={item} reload={()=>this.getHistoricalRelease()} />
                </Menu.Item>
                <style>{`
                    #menu .ant-dropdown-menu-item{padding: 5px 31px;}
                `}</style>
            </Menu>
        )
        return (
            <div className='history-footer-button' style={{display: "flex",gap: "15px", justifyContent: "center"}}>
                <Button onClick={()=>this.close()}>关闭</Button>
                {
                    (item.contentEntry&&item.belongUserAccount===window.currentUser.id)&& (
                    <Dropdown.Button  type="primary" overlay={btnList} onClick={()=>{window.openEditById({configName:"newMediaContentEntryEditor",id:0,params: ({mediaCode:item.code})});}}>
                        录入内容
                    </Dropdown.Button>
                    )
                }
                <style>
                    {
                        `.history-footer-button  .ant-dropdown-trigger { margin-left: 0px !important; }`
                    }
                </style>
            </div>
        )
    }

    render() {
        const { visible,item, dataSource } = this.state;
        const { btnName="历史发布", styleOut = {} } = this.props;
        return (
            <>
                {
                    this.permissionCheck("pms:positionManage:historyPublish")&&<span style={{width: "max-content", cursor: "pointer", ...styleOut}} onClick={()=>this.open(item)}>{btnName}</span>
                }
                <Modal
                    visible={visible}
                    className='historical-release-modal'
                    title="历史发布"
                    maskClosable={false}
                    keyboard={false}
                    onCancel={()=>this.close()}
                    footer={this.renderFooterButton()}
                    width={"70%"}
                    bodyStyle={{
                        paddingBottom:0
                    }}
                    centered
                    afterClose={()=>{
                        // 弹窗关闭后重置数据
                        this.setState({
                            params: {
                                page: 1,
                                size: 10,
                                keyWord: "",
                                startDate: null,
                                endDate: null,
                            },
                            item: {}, //父组件数据
                            dataSource: [],
                            total: 0,
                        })
                    }}
                >
                    <div style={{ display: "flex", flexDirection: "column", height: "100%"}}>
                        {this.renderSearchTemplate()}
                        <Scrollbars autoHeight autoHeightMax={"583px"}>
                            {this.renderTableTemplate()}
                        </Scrollbars>
                        {
                            dataSource.length>0 && this.renderPagination()
                        }
                    </div>
                </Modal>
            </>
        )
    }

    open(record) {
        this.setState({
            visible: true,
        })
        this.getHistoricalRelease();
    }

    close() {
        this.setState({
            visible: false,
        })
    }

    onSearch(params) {
        this.setState({
            params: {
                ...this.state.params,
                ...params,
                page: 1,
                size: 10,
            }
        },()=>{
            this.getHistoricalRelease();
        })
    }

    reset() {
        this.setState({
            params: {
                ...this.state.params,
                keyWord: "",
                startDate: null,
                endDate: null,
            }
        },()=>{
            this.getHistoricalRelease();
        })
    }

    titleClick(record) {
        if(record.url) {
            openNewWindow(record.url)
        }else if(record.cmSiteContent) {
            typeof this.contentShowRef.current.open ==='function'&&this.contentShowRef.current.open(record);
        }
    }

    // 获取历史发布数据
    getHistoricalRelease(callBack) {
        const { params, item } = this.state;
        const codes = [];
        codes.push(item.code);
        request({
            url: "/cm-sites-media-consumer/position/content/manager/list",
            body: {...params,typeId:item.positionTypeId,codes},
            method: "post",
            contentType: "json",
            callBack: (response)=>{
                if (response) {
                    this.setState({
                        dataSource: response.data,
                        total: response.count,
                    })
                }
            }
        })
    }

    // 分页Change
    onPaginationChange(current,pageSize) {
        const { params, total } = this.state;
        if(current>1 &&( (current-1) * pageSize >= total)) {
            this.setState({
                params: {
                    ...params,
                    page: current - 1,
                    size: pageSize,
                },
            },()=>{
                this.getHistoricalRelease();
            })
        }else {
            this.setState({
                params: {
                    ...params,
                    page: current,
                    size: pageSize,
                },
            },()=>{
                this.getHistoricalRelease();
            })
        }
    }
}
export default HistoricalRelease;